// import { api } from "./api";

// export const AgendamentoService = {

//   async findAll() {
//     const response = await api.get("/agendamentos");
//     const data = response.data;

//     if (Array.isArray(data)) {
//       return data;
//     }

//     if (Array.isArray(data?.data)) {
//       return data.data;
//     }

//     return [];
//   },

//   async create(data: any) {
//     const response = await api.post("/agendamentos", data);
//     return response.data;
//   },

//   async update(id: number, data: any) {
//     const response = await api.put(`/agendamentos/${id}`, data);
//     return response.data;
//   },

//   async delete(id: number) {
//     const response = await api.delete(`/agendamentos/${id}`);
//     return response.data;
//   }
// };



import { api } from "./api";

export const AgendamentoService = {
  async findAll() {
    const response = await api.get("/agendamentos");
    const data = response.data;

    if (Array.isArray(data)) return data;
    if (Array.isArray(data?.data)) return data.data;

    return [];
  },

  async create(data: any) {
    const response = await api.post("/agendamentos", data);
    return response.data;
  },

  async update(id: number, data: any) {
    const response = await api.put(`/agendamentos/${id}`, data);
    return response.data;
  },

  async updateStatus(
    id: number,
    status: "agendado" | "concluido" | "cancelado"
  ) {
    const response = await api.patch(`/agendamentos/${id}/status`, {
      status,
    });

    return response.data;
  },

  async delete(id: number) {
    const response = await api.delete(`/agendamentos/${id}`);
    return response.data;
  },
};
